import { render, staticRenderFns } from "./ConferenceModal.vue?vue&type=template&id=4ffc31a9&"
import script from "./ConferenceModal.vue?vue&type=script&lang=js&"
export * from "./ConferenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports